<template>
	<section class="header">
		<div class="header-inner container">
			<div class="row align-items-end">
				<div class="headline-xlg col">My Profile</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'SectionHeader',
}
</script>
